import { useContext } from 'react';
import { Box, Text } from '@hausgold/designsystem';
import { WizardContext } from '../utils/contexts.js';
import FluidMaxContainer from '../components/FluidMaxContainer.js';
import { jsx } from '@emotion/react';
var Error = function Error() {
  var _useContext = useContext(WizardContext),
    WizardHeading = _useContext.components.WizardHeading;
  return jsx(Box, {
    textAlign: "center"
  }, jsx(WizardHeading, null, "Es tut uns leid!"), jsx(FluidMaxContainer, null, jsx(Text, null, "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es in ein paar Minuten erneut.")));
};
export { Error as default };